import { AnyAction, combineReducers } from 'redux';
import { actions } from '../actions';
import { State } from '../types';

const defaultState: State = {
    settings: {
        dataLoaderHasRun: false,
        appInstallationId: null,
        socketStatus: "disconnected",
    },
    applicationStatus: {
        applicationWindowOpen: false,
        applicationName: "",
        openWindows: [],
    },
    userStatus: {
        installationActive: null,
        permissions: [],
    },
    inProgress: [],
    characters: [],
    gameInstance: null,
    currentCharacterId: null,
}

function settingsReducer(state: State["settings"] = defaultState.settings, action: AnyAction): State["settings"] {
    if (actions.updateSettingsAction.match(action)) {
        return { ...state, ...action.payload };
    }
    if (actions.setSettingAction.match(action)) {
        return { ...state, ...action.payload };
    }
    if (actions.emitAction.match(action)) {
        state.socket?.emit(action.payload.name)
    }
    return state;
}

function applicationStatusReducer(state: State["applicationStatus"] = defaultState.applicationStatus, action: AnyAction): State["applicationStatus"] {
    if (actions.openApplicationWindowAction.match(action)) {
        return { ...state, applicationWindowOpen: true, applicationName: action.payload.name };
    }
    if (actions.closeApplicationWindowAction.match(action)) {
        return { ...state, applicationWindowOpen: false, applicationName: "" };
    }
    if (actions.openWindowAction.match(action)) {
        if (state.openWindows.indexOf(action.payload.name) > -1) {
            return state;
        }
        return { ...state, openWindows: [...state.openWindows, action.payload.name] }
    }
    if (actions.closeWindowAction.match(action)) {
        let newOpenWindows = [...state.openWindows].filter(w => w !== action.payload.name);
        // newOpenWindows.splice(newOpenWindows.indexOf(action.payload.name), 1)
        return { ...state, openWindows: newOpenWindows }
    }
    return state;
}

function userStatusReducer(state: State["userStatus"] = defaultState.userStatus, action: AnyAction): State["userStatus"] {
    if (actions.updateUserStatusAction.match(action)) {
        return { ...state, ...action.payload }
    }
    return state;
}

function inProgressReducer(state: State["inProgress"] = defaultState.inProgress, action: AnyAction): State["inProgress"] {
    if (actions.inProgressAction.match(action)) {
        return [...state, action.payload]
    }
    if (actions.notInProgressAction.match(action)) {
        let newState = [...state]
        newState.splice(newState.indexOf(action.payload), 1)
        return newState
    }
    return state;
}

function charactersReducer(state: State["characters"] = defaultState.characters, action: AnyAction): State["characters"] {
    if (actions.setCharactersAction.match(action)) {
        console.log("Setting characters", action.payload)
        return action.payload
    }
    return state;
}

function gameInstanceReducer(state: State["gameInstance"] = defaultState.gameInstance, action: AnyAction): State["gameInstance"] {
    if (actions.setGameInstanceAction.match(action)) {
        console.log("Setting game instance", action.payload);
        if (!action.payload) { return null }
        return { ...action.payload }
    }
    if (actions.updateCharacterLocation.match(action)) {
        if (state === null) { return null }

        const subInstances = state.subInstances

        if (action.payload.subInstanceId) {
            const s = subInstances.find(c => c.id === action.payload.subInstanceId)
            const l = s?.characterLocations.find(c => c.charId === action.payload.characterId)
            if (l) {
                l.nodeId = action.payload.nodeId
            }
        }

        return {
            ...state,
            characterLocations:
                [
                    ...state!.characterLocations.filter(l => l.charId !== action.payload.characterId),
                    {
                        charId: action.payload.characterId,
                        nodeId: action.payload.nodeId,
                        subInstanceId: action.payload.subInstanceId
                    }
                ],
                subInstances: subInstances
        }
    }
    return state;
}

function currentCharacterIdReducer(state: State["currentCharacterId"] = defaultState.currentCharacterId, action: AnyAction): State["currentCharacterId"] {
    if (actions.setCurrentCharacterIdAction.match(action)) {
        return action.payload
    }
    return state;
}

export default combineReducers({
    settings: settingsReducer,
    applicationStatus: applicationStatusReducer,
    userStatus: userStatusReducer,
    inProgress: inProgressReducer,
    characters: charactersReducer,
    gameInstance: gameInstanceReducer,
    currentCharacterId: currentCharacterIdReducer,
});
